import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/chatgpt-business-offer/page.tsx");
